import "./App.css";
import { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import Profile from "./pages/Profile/Profile";
import Login from "./pages/Login/Login";
import Signup from "./pages/Signup/Signup";
import Forget from "./pages/Forget/Forget";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ActiveAccount from "./pages/ActiveAccount/ActiveAccount";
import Private from "./store/routing/private";

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<>Loading...</>}>
        <Routes>
          <Route element={<Private />}>
            <Route path="/" element={<Home />} />
          </Route>
          <Route path="profile" element={<Profile />} />
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="forget" element={<Forget />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="active-account" element={<ActiveAccount />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
